/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'

import './ButtonGroup.css'

export default class ButtonGroup extends Component {

    constructor(props) {
        super(props)

        this.onElementChange = this.onElementChange.bind(this)
        let value = this.props.value || null
        if (!value && this.props.type === 'checkbox') {
            value = []
        }
        this.state = {
            value
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value && nextProps.value !== undefined) {
            this.setState({
                value: nextProps.value
            })
        }
    }

    render() {
        const type = this.props.type
        let body = this.props.children
        if (type === 'radio' || type === 'checkbox') {
            body = body.map((child, index) => {
                const activeClass = this.isElementActive(child) ? 'active' : ''
                return (<button key={index} {...child.props} type="button" onClick={this.onElementChange} className={activeClass}>{child.props.children}</button>)
            })
        } 
        return (
            <div className={'ButtonGroup'}>
                {body}
            </div>
        )
    }

    onElementChange(e) {
        let res = null
        if (this.props.type === 'checkbox') {
            res = [...this.state.value]
            const ix = res.indexOf(e.target.value)
            if (ix > -1) {
                res.splice(ix, 1)
            } else {
                res.push(e.target.value)
            }
        } else {
            res = e.target.value
        }
        this.setState({
            value: res
        })
        if (this.props.onChange) {
            this.props.onChange({currentTarget: {value: res}})
        }
    }

    isElementActive(el) {
        if (this.props.type === 'checkbox') {
            return this.state.value.indexOf(el.props.value) > -1
        } else {
            return el.props.value === this.state.value
        }
    }
}
